module.exports = __webpack_public_path__ + "static/media/icon-menu.1009d1e2.svg";